import { useEffect } from 'react';
import handshakeIcon from 'assets/icons/handshake.svg';
import { usePageFilters } from 'customHooks/usePageFilters';
import { DealFilters, DealStatus } from 'components/common/types/Deal.types';
import MetricsWidget from '../MetricsWidget';
import { useMetricsData } from '../useMetricsData';

const LiveDealsMetrics: React.FC = () => {
  const { numberOfLiveDeals, isLoadingLiveDeals, getNumberOfLiveDeals } = useMetricsData();

  const { changeFilters } = usePageFilters<DealFilters>('insights/');

  useEffect(() => {
    getNumberOfLiveDeals();
  }, []);

  return (
    <div className="relative flex w-full h-20 group">
      <div
        className="w-full h-full absolute group-hover:cursor-pointer"
        role="presentation"
        data-test-id="live-deals-overlay"
        onClick={() => {
          changeFilters({ status: DealStatus.LIVE });
        }}
      />
      <MetricsWidget
        name="Live campaigns"
        value={numberOfLiveDeals === null ? '-' : numberOfLiveDeals}
        icon={handshakeIcon}
        isLoaderVisible={isLoadingLiveDeals}
      />
    </div>
  );
};

export default LiveDealsMetrics;
